import React, { useState } from 'react'
import s from './Reviews.module.css'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'
import { useTranslations } from 'next-intl'
import { Rating } from '@components/ui'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import 'swiper/css/keyboard'
import 'swiper/css/mousewheel'
import 'swiper/css/navigation'
import { Keyboard, Mousewheel, Navigation } from 'swiper/modules'

export interface IListForm {
  name: string
  rating: any
  product: string,
  content: string,
}

export interface ReviewsProps {
  title: any
  className: string
  rating: any
  reviewers: any
  recommended: any
  list?: Array<IListForm>
}

const Reviews: React.FC<ReviewsProps> = ((props) => {
  const {
    className,
    title,
    rating,
    reviewers,
    recommended,
    list
  } = props

  const t = useTranslations('Global')

  const [swiper, setSwiper] = useState(useSwiper())

  // @ts-ignore
  return (
    <div className={s.root}>
      <div className={'mx-auto ' + (className === 'product' ? '' : 'text-center') + ' text-neutral900'}>
        <h3 className={'text-heading01Mobile md:text-heading02 font-medium px-space6 md:px-space16 pb-space4 md:pb-0'}>{title}</h3>
        {className === 'product' && <div className={'mb-space4 md:mb-10'}>
          <div className={'inline-block px-space6 md:px-space16'}>
            <p className={'text-heading01 pt-space2 md:pt-space6 block'}>{rating}</p>
            <p className={'block py-0'}><Rating value={rating} /><span
              className={'text-button text-neutral700 font-medium font-mono block md:inline'}>[{reviewers} {t('reviewers')}]</span></p>
          </div>
          <div className={'inline-block md:ml-space20 align-top'}>
            <p className={'text-heading01 pt-space2 md:pt-space6 block'}>{recommended}%</p>
            <p className={'block py-space4 max-w-e180 md:max-w-full'}><span
              className={'block text-button line-height1 text-neutral700 md:mb-space1 font-medium font-mono'}>{t('userRecommendedProduct')}</span></p>
          </div>
        </div>
        }
        {className !== 'product' && <div className={'mb-space16 md:mb-12 px-space6 md:px-space16'}>
          <p className={'text-heading01 pt-space4 md:pt-space7 block'}>{rating}</p>
          <p className={'block py-0'}><Rating value={rating} /></p>
          <p
            className={'text-button text-neutral700 font-medium font-mono'}>[ {reviewers} {t('reviewers')} / {recommended}% {t('userRecommended')} ]</p>
        </div>
        }
      </div>

      <div className={s.separator + ' md:mx-space10'}></div>

      <div className={'mt-space8 md:mt-space16 mb-0 md:mb-space12 xl:mx-space16'}>
        {list && list?.length > 1 &&
          <Swiper
            cssMode={true}
            breakpoints={{
              0: {
                slidesPerView: 1.2
              },
              800: {
                slidesPerView: 2.2
              },
              1280: {
                slidesPerView: Math.min(list?.length, 3)
              }
            }}
            navigation={true}
            mousewheel={true}
            keyboard={true}
            onSwiper={(s: any) => {
              setSwiper(s)
            }}
            modules={[Mousewheel, Keyboard, Navigation]}
            className={s.myReviewSwiper}

          >{list && list.map((item, index) => {
              return <SwiperSlide key={'reviews' + index} className={s.swiperSlide}><div className={s.reviewElement + ' bg-neutral50 rounded-cornerS p-space8'}>
                  <p className={'text-paragraph01 font-medium'}>{item.name}</p>
                  <p className={'text-button font-mono mt-3 font-medium'}>{item.product}</p>
                  <p className={''}><Rating value={item.rating} small={true} /></p>
                  <p className={'text-paragraph02'}>{item.content}</p>
                </div></SwiperSlide>
            })}
          </Swiper>
        }
      </div>
    </div>
  )
})

export default Reviews
